import React from "react";
import { DatePicker, Form, Text } from "rsuite";

const AnnotatedDatePicker = ({label, name, subtitle = () => null, annotation = () => null, onChange, dateConvertor = (date) => date, ...rest}) => {
    const onInternalChange = (date) => {
        let convertedDate = dateConvertor(date);
        onChange(convertedDate);
    }
    return (
        <>
            <Form.Group controlId={name}>
                <Form.ControlLabel>
                    <Text className="text-bold">{label}</Text>
                    <Text>{subtitle()}</Text>
                </Form.ControlLabel>
                
                <DatePicker name={name} onChange={onInternalChange} {...rest}/>
                {annotation()}
            </Form.Group>
            
        </>
    )
}

export default AnnotatedDatePicker;